/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'intercom': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M279.459 535.273c11.683 117.62 110.918 209.454 231.564 209.454 120.692 0 219.927-91.834 231.586-209.454h46.755c-11.217 135.68-119.389 243.851-255.069 255.046v70.772h139.637a23.273 23.273 0 110 46.545H348.113a23.273 23.273 0 010-46.545H487.75v-70.772c-135.68-11.195-243.829-119.39-255.023-255.046h46.732zm231.564-395.637a186.182 186.182 0 01186.181 186.182V512a186.182 186.182 0 11-372.363 0V325.818a186.182 186.182 0 01186.182-186.182zm0 46.546a139.636 139.636 0 00-139.637 139.636V512a139.636 139.636 0 10279.273 0V325.818a139.636 139.636 0 00-139.636-139.636z"/>'
  }
})
